import https, { downloadExcel, downloadFile } from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { ContentType, Method } from 'axios-mapper'
import {
  JHTransactionRecordPageModel,
  JHTransactionRecordPageParamModel, TransactionRecordHistoryPageModel, TransactionRecordHistoryPageParamModel,
  XYTransactionRecordModel,
  XYTransactionRecordParamModel,
  ZHTransactionRecordPageModel,
  ZHTransactionRecordPageParamModel
} from '@/model/paymentSlip/paymentTransactionRecordModel'

const baseUrl = '/base/payment/transaction/record'

export const getXYTransactionRecordList = (params: XYTransactionRecordParamModel) => {
  return https()
    .request<RootObject<XYTransactionRecordModel[]>>(baseUrl + '/list/xy', Method.POST, params, ContentType.json)
}

export const getJHTransactionRecordPageList = (params: JHTransactionRecordPageParamModel) => {
  return https()
    .request<RootObject<JHTransactionRecordPageModel>>(baseUrl + '/list/jh', Method.POST, params, ContentType.json)
}

export const getZHTransactionRecordPageList = (params: ZHTransactionRecordPageParamModel) => {
  return https()
    .request<RootObject<ZHTransactionRecordPageModel>>(baseUrl + '/list/zh', Method.POST, params, ContentType.json)
}

export const getTransactionRecordHistoryPageList = (params: TransactionRecordHistoryPageParamModel) => {
  return https()
    .request<RootObject<TransactionRecordHistoryPageModel>>(baseUrl + '/history/list/page', Method.POST, params, ContentType.json)
}

export const exportTransactionRecordHistory = (params: TransactionRecordHistoryPageParamModel) => {
  return downloadExcel(baseUrl + '/history/list/export', Method.POST, params)
}

export const exportXYTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelXYTemplate', Method.GET, undefined)
}

export const exportJHTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelJHTemplate', Method.GET, undefined)
}

export const exportZHTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelZHTemplate', Method.GET, undefined)
}

export const batchXYDownloadTemplate = (params: FormData) => {
  return downloadFile(baseUrl + '/batch/xy/receipt', Method.POST, params)
}

export const batchJHDownloadTemplate = (params: FormData) => {
  return downloadFile(baseUrl + '/batch/jh/receipt', Method.POST, params)
}

export const batchZHDownloadTemplate = (params: FormData) => {
  return downloadFile(baseUrl + '/batch/zh/receipt', Method.POST, params)
}
